/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Antibiotic from './antibiotic';
import AntibioticDetail from './antibiotic-detail';
import AntibioticUpdate from './antibiotic-update';
import AntibioticDeleteDialog from './antibiotic-delete-dialog';

const AntibioticRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Antibiotic />} />
    <Route path="new" element={<AntibioticUpdate />} />
    <Route path=":id">
      <Route index element={<AntibioticDetail />} />
      <Route path="edit" element={<AntibioticUpdate />} />
      <Route path="delete" element={<AntibioticDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AntibioticRoutes;
